export default __webpack_public_path__ + "static/media/9.1a4ce2d2.jpg";